import moment from 'moment';
import gestionErreur from '@/services/general/gestionErreur';
import reseauxParametreInitializer from '@/services/patrimoine/reseauxParametreInitializer';
import { ZOOM_DEFAULT_RESEAUX, CENTER_RESEAUX_DEFAULT, RESEAU_FROM_VENTES_RESEAUX,
  FACES_FROM_VENTES_RESEAUX, ISOCHRONE_DEFAULT, TYPE_LAYER_EMPTY } from '@/configuration/carteConf';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { filtrer } from '@/services/general/listeFilter';
import GetListeElementUniqueParPropriete from '@/services/general/listeFilterDynamique';
import { reseauNumeriqueExtensionInitializer } from '@/services/panier/extensionInitializer';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import defineCenter from '@/services/general/defineCenter';
import { SANS_TYPE_VENTE } from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import { browseReseauxNumerique, sendColor } from '../../api/reseauxNumerique';
import * as types from './venteReseauxNumerique-mutation-type';
import * as allTypes from '../mutation-type';


function initialState() {
  return {
    reseaux: [],
    reseauxWithFilter: [],
    showReseaux: false,
    dateDeVisualisation: new Date(),
    avecConfreres: false,
    centerReseaux: CENTER_RESEAUX_DEFAULT,
    isochrone: ISOCHRONE_DEFAULT,
    typeLayerGeoMarketing: TYPE_LAYER_EMPTY,
    zoomCartoReseaux: ZOOM_DEFAULT_RESEAUX,
    filtres: {},
    filtresDynamiques: [],
    selectedFiltreDynamique: FILTRE_DYNAMIQUE_VIDE,
    filterChanged: true,
    markersReseaux: [],
    markersFacesParReseaux: [],
    selectedMarkerFacesDeReseaux: '',
    selectedMarkerReseaux: '',
    zoomMarker: null,
    activeTabReseau: 0,
    criterePlanning: {},
    typeVente: SANS_TYPE_VENTE,
    pointsAddress: [],
    address: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_ISOCHRONE](state, isochrone) {
    state.isochrone = isochrone;
  },
  [types.SET_TYPE_LAYER_GEO_MARKETING](state, typeLayerGeoMarketing) {
    state.typeLayerGeoMarketing = typeLayerGeoMarketing;
  },
  [types.SET_RESEAUX](state, reseaux) {
    state.reseaux = reseaux;
  },
  [types.SET_RESEAUX_WITH_FILTER](state, reseauxWithFilter) {
    state.reseauxWithFilter = reseauxWithFilter;
  },
  [types.SET_DATE_DE_VISUALISATION](state, dateDeVisualisation) {
    state.dateDeVisualisation = dateDeVisualisation;
  },
  [types.SET_SHOW_RESEAUX](state, showReseaux) {
    state.showReseaux = showReseaux;
  },
  [types.TRIE_RESEAUX](state) {
    state.reseaux.sort((a, b) => {
      if (a.ville < b.ville) return -1;
      else if (a.ville === b.ville) {
        if (a.libelle < b.libelle) return -1;
        else if (a.code === b.code) return 0;
      }
      return 1;
    });
  },
  [types.SET_AVEC_CONFRERES](state) {
    state.avecConfreres = !state.avecConfreres;
  },
  [types.SET_CENTER_RESEAUX](state, center) {
    state.centerReseaux = center;
  },
  [types.SET_ZOOM_CARTO_RESEAUX](state, zoomCartoReseaux) {
    state.zoomCartoReseaux = zoomCartoReseaux;
  },
  [types.ADD_FILTER_PROPERTY](state, { property, valueProperty }) {
    state.filtres[property] = valueProperty;
  },
  [types.REMOVE_FILTER_PROPERTY](state, property) {
    state.filtres[property] = {};
    state.filtresDynamiques.forEach((filtreDynamique) => {
      if (filtreDynamique.id === property) {
        state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtreDynamique), 1);
      }
    });
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.REMOVE_FILTER](state) {
    state.filtres = {};
    state.filtresDynamiques = [];
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.ADD_FILTER_DYNAMIQUE](state, value) {
    const filtre = state.filtresDynamiques.find((el) => { return el.id === value.id; });
    if (filtre) {
      state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtre), 1, value);
    } else {
      state.filtresDynamiques.unshift(value);
    }
  },
  [types.SELECT_FILTRE_DYNAMIQUE](state, filtre) {
    state.selectedFiltreDynamique = filtre;
  },
  [types.SET_FILTER_CHANGED](state) {
    state.filterChanged = !state.filterChanged;
  },
  [types.SET_ACTIVE_TAB_RESEAU](state, activeTabReseau) {
    state.activeTabReseau = activeTabReseau;
  },
  [types.SET_ZOOM_MARKER](state, zoomMarker) {
    state.zoomMarker = zoomMarker;
  },
  [types.SET_SELECTED_MARKER_FACES_DE_RESEAUX](state, selectedMarker) {
    state.selectedMarkerFacesDeReseaux = selectedMarker;
  },
  [types.SET_SELECTED_MARKER_RESEAUX](state, selectedMarker) {
    state.selectedMarkerReseaux = selectedMarker;
  },
  [types.SET_MARKER_RESEAUX](state, markersReseaux) {
    state.markersReseaux = markersReseaux;
  },
  [types.SET_MARKER_FACES_DE_RESEAUX](state, markersFacesParReseaux) {
    state.markersFacesParReseaux = markersFacesParReseaux;
  },
  [types.SET_CRITERE_PLANNING](state, critere) {
    state.criterePlanning = critere;
  },
  [types.SET_TYPE_VENTE](state, typeVente) {
    state.typeVente = typeVente;
  },
  [types.SET_RESEAU_SELECTED](state, payload) {
    const reseau = state.reseaux.find((el) => { return el.num === payload.num; });
    if (reseau) {
      reseau.selected = payload.value;
    }
  },
  [types.SET_POINTS_ADDRESS](state, pointsAddress) {
    state.pointsAddress = pointsAddress;
  },
  [types.SET_FILTER_ADDRESS](state, address) {
    state.address = address;
  },
};

const specAffichage = {
  day: {
    widescreen: {
      unit: 'days', size: 32, startOf: false,
    },
    tablet: {
      unit: 'days', size: 14, startOf: false,
    },
  },
  week: {
    widescreen: {
      unit: 'weeks', size: 10, startOf: 'isoWeek',
    },
    tablet: {
      unit: 'weeks', size: 5, startOf: 'isoWeek',
    },
  },
};
let adresseReseauxNumeriques = null;

const actions = {
  rechercheReseaux: ({ getters, commit, dispatch, rootGetters }) => {
    return new Promise((resolve, reject) => {
      const dateDeVisualisation = moment(getters.dateDeVisualisation).format('YYYYMMDD');
      const azimut = rootGetters['user/afficherAzimut'];
      commit(types.SET_SHOW_RESEAUX, false);
      browseReseauxNumerique(dateDeVisualisation, getters.avecConfreres).then((response) => {
        const alreadySelected = rootGetters['panier/reseauxNumeriquesPanier'];
        response.data.forEach((el) => {
          el.selected = false;
        });
        alreadySelected.forEach((selectedItem) => {
          const reseau = response.data.find((el) => {
            return el.num === selectedItem.num;
          });
          if (reseau) {
            reseau.selected = true;
          } else {
            response.data.push(selectedItem);
          }
        });
        response.data = reseauxParametreInitializer(response.data);
        commit(types.SET_RESEAUX, response.data);
        commit(types.TRIE_RESEAUX, getters.reseaux);
        commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseaux, getters.filtres));
        commit(types.SET_MARKER_RESEAUX,
          fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxWithFilter, azimut));
        dispatch('fromFacesReseauxToMarkers');
        commit(types.SET_CENTER_RESEAUX, defineCenter(getters.markersReseaux,
          getters.centerReseaux));
        dispatch('changementDateDebutPlanning',
          { debut: moment(getters.dateDeVisualisation),
            granularity: 'day',
          },
        );
        commit(types.SET_SHOW_RESEAUX, true);
        resolve();
      }).catch((e) => {
        reject(e.code);
        gestionErreur('Erreur lors de la récupération des reseaux Numériques', e);
      });
    });
  },
  gestionFiltres: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_FILTER_CHANGED);
    commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseaux, getters.filtres));
    commit(types.SET_MARKER_RESEAUX, fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX,
      getters.reseauxWithFilter, azimut));
    dispatch('fromFacesReseauxToMarkers');
    commit(types.SET_SELECTED_MARKER_RESEAUX, '');
  },
  ajoutFiltresDynamiques: ({ getters, commit }, payload) => {
    if (!getters.filtresDynamiques.find((el) => {
      return el.id === payload.valueProperty.id;
    })) {
      const prop = payload.valueProperty;
      prop.valeur = (GetListeElementUniqueParPropriete(getters.reseaux,
        payload.valueProperty.id));
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
    }
  },
  fromFacesReseauxToMarkers: ({ getters, rootGetters, commit }) => {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxWithFilter.forEach((reseau) => {
      const faces = reseau.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0) {
          face.selected = reseau.selected;
          if (reseau.couleur) {
            face.color = reseau.couleur;
          }
          face.libelleReseau = reseau.libelle;
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACES_DE_RESEAUX, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  envoyerCouleurReseau: async ({ dispatch }, payload) => {
    try {
      await sendColor(payload.reseau.num, payload.couleur);
      dispatch('updateMarkerReseau');
    } catch (e) {
      gestionErreur(`Erreur lors de l'envoi de la couleur du reseau Numérique n°${payload.reseau.num}`, e);
    }
  },
  updateMarkerReseau: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxWithFilter, azimut));
    dispatch('fromFacesReseauxToMarkers');
  },
  changementDateDebutPlanning: ({ getters, commit }, payload) => {
    let newStartDate = payload.debut;
    if (!newStartDate.isValid()) {
      newStartDate = moment();
    }
    let breakpoint = 'tablet';
    if (window.innerWidth >= 1216) { // Magic constant coming from bulma
      breakpoint = 'widescreen';
    }
    if (specAffichage[payload.granularity][breakpoint].startOf) {
      newStartDate.startOf(specAffichage[payload.granularity][breakpoint].startOf);
    }
    if (newStartDate === getters.criterePlanning.dateStart &&
      breakpoint === getters.criterePlanning.breakpoint &&
      payload.granularity === getters.criterePlanning.granularity) {
      return;
    }
    const critere = {};
    critere.size = specAffichage[payload.granularity][breakpoint].size;
    critere.unit = specAffichage[payload.granularity][breakpoint].unit;
    const newEndDate = newStartDate.clone().add(critere.size, critere.unit).add(-1, 'days');
    const newDuration = newEndDate.diff(newStartDate, 'days') + 1;
    critere.granularity = payload.granularity;
    critere.breakpoint = breakpoint;
    critere.dateStart = newStartDate;
    critere.dateEnd = newEndDate;
    critere.days = newDuration;
    commit(types.SET_CRITERE_PLANNING, critere);
  },
  gestionPanier: ({ getters, rootGetters, dispatch }, payload) => {
    if (getters.typeVente === SANS_TYPE_VENTE) {
      return;
    }
    const reseauNumerique = getters.reseaux.find((el) => { return el.num === payload.num; });
    if (!reseauNumerique) {
      return;
    }
    const produit = rootGetters['panier/reseauxNumeriquesPanier'].find(produit =>
      produit.num === payload.num
      && produit.extensionOpportunite.typeTarification === payload.tarification);
    if (!produit) {
      dispatch('ajoutAuPanier', { reseauNumerique: reseauNumerique, tarification: payload.tarification, periode: payload.periode });
    } else if (!produit.extensionOpportunite.periodeModifieManuellement
      && !produit.extensionOpportunite.periode.includes(' ' + payload.periode + ' ')
      && !produit.extensionOpportunite.reseauPersoGuid) {
      dispatch('ajoutPeriodeAuPanier', { produit: produit, periode: payload.periode, tarification: payload.tarification });
    }
    dispatch('updateMarkerReseau');
  },
  ajoutAuPanier: ({ commit, dispatch, getters }, payload) => {
    const panneauAAjouter = reseauNumeriqueExtensionInitializer(Object.assign({},
      payload.reseauNumerique),
    payload.tarification, payload.periode);
    panneauAAjouter.selected = false;
    if (getters.address) {
      if (getters.address.libelleAdresse.toUpperCase() === panneauAAjouter.ville) {
        adresseReseauxNumeriques = {
          lat: getters.address.lat,
          lng: getters.address.lng,
          nom: 'adresseReseauxNumeriques',
        };
      }
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_RESEAU_NUMERIQUE, panneauAAjouter, { root: true });
    commit('panier/' + typesPanier.ADD_ADRESSES_PRODUITS, adresseReseauxNumeriques, { root: true });
    dispatch('panier/genererMarkerFaceReseauxNumerique', null, { root: true });
  },
  ajoutPeriodeAuPanier: ({ commit }, payload) => {
    commit('panier/' + typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE, payload.produit, { root: true });
    payload.produit.extensionOpportunite.periode += `- ${payload.periode} `;
    if (payload.produit.extensionOpportunite.quantite) {
      payload.produit.extensionOpportunite.quantite =
        parseInt(payload.produit.extensionOpportunite.quantite, 10) + 1;
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_RESEAU_NUMERIQUE, payload.produit, { root: true });
  },
};

const getters = {
  reseaux: (state) => {
    return state.reseaux;
  },
  reseauxWithFilter: (state) => {
    return state.reseauxWithFilter;
  },
  showReseaux: (state) => {
    return state.showReseaux;
  },
  dateDeVisualisation: (state) => {
    return state.dateDeVisualisation;
  },
  avecConfreres: (state) => {
    return state.avecConfreres;
  },
  centerReseaux: (state) => {
    return state.centerReseaux;
  },
  isochrone: (state) => {
    return state.isochrone;
  },
  typeLayerGeoMarketing: (state) => {
    return state.typeLayerGeoMarketing;
  },
  zoomCartoReseaux: (state) => {
    return state.zoomCartoReseaux;
  },
  filtres: (state) => {
    return state.filtres;
  },
  filtresDynamiques: (state) => {
    return state.filtresDynamiques;
  },
  filtresDynamiquesSpe: (state) => (id) => {
    return state.filtresDynamiques.find((el) => { return el.id === id; });
  },
  selectedFiltreDynamique: (state) => {
    return state.selectedFiltreDynamique;
  },
  filterChanged: (state) => {
    return state.filterChanged;
  },
  activeTabReseau: (state) => {
    return state.activeTabReseau;
  },
  zoomMarker: (state) => {
    return state.zoomMarker;
  },
  markersReseaux: (state) => {
    return state.markersReseaux;
  },
  markersFacesParReseaux: (state) => {
    return state.markersFacesParReseaux;
  },
  selectedMarkerFacesDeReseaux: (state) => {
    return state.selectedMarkerFacesDeReseaux;
  },
  selectedMarkerReseaux: (state) => {
    return state.selectedMarkerReseaux;
  },
  criterePlanning: (state) => {
    return state.criterePlanning;
  },
  typeVente: (state) => {
    return state.typeVente;
  },
  pointsAddress: (state) => {
    return state.pointsAddress.filter(el => el.coordonnees);
  },
  address: (state) => {
    return state.address;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteReseauxNumerique.js